import { Button } from '@dgshahr/ui-kit'
import { notFound } from '@/assets/images/images'
import Header from '@/components/landing/header/Header'
import Footer from '@/components/landing/footer/Footer'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header />
      <div className="w-full tablet:h-[700px] bg-gray-100 flex flex-col-reverse tablet:grid tablet:grid-cols-12 items-center pb-3">
        <div className="tablet:w-[520px] h-[272px] w-full p-4 tablet:p-2 col-start-3 col-end-7">
          <p className="font-heading-4 text-primary-500 ss02 text-lg font-bold">
            خطای 404
          </p>
          <p className="text-2xl font-bold my-4">
            صفحه‌ای که دنبال آن بودید پیدا نشد!
          </p>
          <p className="text-gray-500 font-caption mb-3">
            می‌توانید محصول مورد نظر خود را از طریق کادر جستجو پیدا کنید و یا از
            طریق دکمه زیر به صفحه اصلی فروشگاه برگردید.{' '}
          </p>
          <Button variant="outline" onClick={() => navigate('/')}>
            بازگشت به صفحه اصلی
          </Button>
        </div>
        <img
          className="overflow-hidden tablet:!h-[640px] tablet:!w-[546px] h-[300px] mt-10 w-full col-start-8 col-end-12 object-cover"
          src={notFound}
          alt="notfound"
        />
      </div>
      <Footer />
    </>
  )
}

export default NotFound
